export const getPartnerNameById = (partnerId: any, partners: any) => {
  if (partners) {
    const partner = partners.find((p: any) => p.id === partnerId);
    return partner ? partner.name : "Partner not found";
  }
  return "";
};
